var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"video"},[_c('video',{staticClass:"video-js vjs-default-skin",attrs:{"id":_vm.id,"controls":"","playsinline":"","autoplay":"autoplay","width":"500px"}},[_c('source',{attrs:{"src":_vm.url1,"type":"application/x-mpegURL"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }